import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from './assets/logo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [facilitiesOpen, setFacilitiesOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const closeMenu = () => {
    setMenuOpen(false);
    setFacilitiesOpen(false);
  };

  const toggleFacilities = () => {
    setFacilitiesOpen(!facilitiesOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">

        {/* Logo */}
        <div className="logo-container">
          <img src={logo} alt="Mwangaza Logo" className="logo" />
        </div>

        {/* Hamburger for small screens */}
        <div className="hamburger" onClick={toggleMenu}>
          <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </div>

        {/* Navigation Links */}
        <div className={`nav-links-container ${menuOpen ? 'open' : ''}`}>
          <div className="nav-links">
            <Link to="/" onClick={closeMenu}>Home</Link>
            <Link to="/about" onClick={closeMenu}>About</Link>
            <Link to="/services" onClick={closeMenu}>Services</Link>
            
            {/* Our Facilities Dropdown */}
            <div className="dropdown">
              <div className="dropdown-toggle" onClick={toggleFacilities}>
                Our Facilities <i className={`fas fa-caret-${facilitiesOpen ? 'up' : 'down'}`}></i>
              </div>
              {facilitiesOpen && (
                <div className="dropdown-menu">
                  <Link to="/facilities/reception" onClick={closeMenu}>Reception</Link>
                  <Link to="/facilities/counselling-room-1" onClick={closeMenu}>Counselling Room 1</Link>
                  <Link to="/facilities/counselling-room-2" onClick={closeMenu}>Counselling Room 2</Link>
                  <Link to="/facilities/lab" onClick={closeMenu}>Laboratory</Link>
                  <Link to="/facilities/consultation-room" onClick={closeMenu}>Consultation Room</Link>
                </div>
              )}
            </div>

            <Link to="/media" onClick={closeMenu}>Media</Link>
            <Link to="/contact" onClick={closeMenu}>Contact</Link>
          </div>

          {/* Social Icons */}
          <div className="social-icons">
            <a href="tel:+254792994876" title="Call">
    <i className="fas fa-phone"></i>
  </a>

  {/* WhatsApp link */}
  <a href="https://wa.me/254792994876" target="_blank" rel="noopener noreferrer" title="WhatsApp">
    <i className="fab fa-whatsapp"></i>
  </a>
  
            <a href="https://www.facebook.com/profile.php?id=61577658993263" target="_blank" rel="noopener noreferrer" title="Facebook">
  <i className="fab fa-facebook"></i>
</a>


          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
